<h1 mat-dialog-title>Remove User</h1>
<div mat-dialog-content>Are you sure you want to remove this user?</div>
<div mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>No</button>
  <button mat-raised-button color="primary" [mat-dialog-close]="true" (click)="removeUser(data)">Yes</button>
</div>